<template>
  <v-container fluid grid-list-sm class="header-container">
    <v-layout row wrap>
      <v-flex xs12 pa-3 class="header-content text-xs-center white--text headline font-weight-medium">
        Admin
      </v-flex>

      <v-container fluid grid-list-sm>
        <v-flex xs12 v-for="(link, i) in links" :key="i" pa-2>
          <v-card class="elevation-2" >
            
            <v-list two-line class="pa-0">
              <v-list-tile
                avatar
                :to="link.to"
              >

                <v-list-tile-action class="text-xs-center">
                  <v-avatar size="50" style="border: 1px solid red" :color="link.color">
                    <v-icon size="25" color="white"> 
                      {{link.icon}}
                    </v-icon>
                  </v-avatar>
                </v-list-tile-action>
                

                <v-list-tile-content class="pl-2" >
                  <v-list-tile-title class="title">{{link.title}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{link.text}}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                  <v-avatar>
                    <v-icon size="70"> 
                      mdi-chevron-right
                    </v-icon>
                  </v-avatar>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex'
export default {
  data: () => ({
    links: [
      {
        title: 'Payroll',
        text: 'View summaries for a time period',
        to: '/admin/payroll',
        // icon: 'mdi-clipboard-text',
        icon: 'mdi-cash-multiple',
        color: '#308C7D'
      },
      {
        title: "View People's Timesheets",
        text: "View and Edit other's timesheets",
        to: '/admin/viewTimesheets',
        icon: 'mdi-account-clock',
        color: '#224252'
      },
      {
        title: "Forward Leave Planner",
        text: "View upcoming leave",
        to: '/admin/forwardLeavePlanner',
        icon: 'mdi-account-clock',
        color: '#224252'
      },
      {
        title: "Scheduled Reminders",
        text: "Update automated email timers",
        to: '/admin/reminders',
        // icon: 'mdi-account-alert',
        icon:'mdi-bell-ring',
        color: '#87198B'
      },
      {
        title: 'Users & Managers',
        text: 'Edit someone\'s manager',
        to : '/admin/userManager',
        icon: 'mdi-account-tie',
        color: '#3D346A'
      },
      {
        title: 'Clients',
        text: 'View and edit all clients',
        to: '/admin/clients',
        // icon: 'mdi-briefcase',
        icon: 'mdi-account-group',
        color: '#A03915'
      },
      {
        title: 'Projects',
        text: 'View and edit all projects',
        to: '/admin/projects',
        icon: 'mdi-file-document-box-multiple',
        color: '#224252'
      },
      {
        title: 'Activities',
        text: 'View and edit all activities',
        to: '/admin/activities',
        icon: 'mdi-table-large',
        // icon: 'mdi-file-document-box',
        color: '#308C7D'
      }, {
        title: 'Practices',
        text: 'View and edit all Practices',
        to: '/admin/practices',
        // icon: 'mdi-folder-account',
        icon: 'mdi-karate',
        color: '#1E618A'
      }, {
        title: 'Statement of Work',
        text: 'View and edit Statement of Work',
        to: '/admin/statements',
        // icon: 'mdi-receipt',
        icon: 'mdi-briefcase',
        color: '#52224A'
      }, {
        title: 'Master Data',
        text: 'View master data',
        to: '/admin/master',
        icon: 'mdi-database',
        color: '#3F7E45'
      }
    ]
  }),
  computed: {
    ...mapState('api', ['timesheetData'])
  },
  created() {
    if(this.timesheetData.length == 0) {
      var self = this
      this.$timesheetApi.getData().then(data => {
        self.setTimesheetData(data)
      })
    }    
  },
  methods: {
    ...mapMutations('api', ['setTimesheetData']),
    routeTo(link) {
      this.$router.push(link)
    }
  }
}
</script>

<style>
</style>
